(function () {
  'use strict';

  angular
    .module('etsReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('etsReport', {
        url: '/ets-report',
        views:{
          'etsReportView': {
            templateUrl: 'ets-report/views/ets-report.tpl.html',
            controller: 'EtsReportCtrl',
            controllerAs: 'etsReport'
          }
        }
      });
  }
}());
